import {FC} from 'react'
import { Assessment } from '../../core/_models'

type Props = {
  questions: Assessment
}

const QuestionsIdCell: FC<Props> = ({questions}) => {
  return (
    <>
      {
        <div className='d-flex align-items-center'>
        {/* begin:: Avatar */}
        <div className='d-flex flex-column'>
            {questions.id}
        </div>
      </div>
      }
    </>
  )
}

export {QuestionsIdCell}
